export const heroCBPV5 = {
  image:
    'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_34SideFront.jpg',
  title: 'Klimatpremie för\n lätta ellastbilar.',
  subtitle: 'Ansök om klimatpremie för PV5 Cargo.',
  position: 'bottom' as const,
  hAlign: 'left' as const,
  titleClass: 'text-[clamp(38px,8vw,64px)] font-[400]',
  subtitleClass: 'text-[clamp(14px,5vw,24px)] font-[300]',
};

export const text001 =
  'Företag, kommuner och regioner som ska investera i en eldriven lätt lastbil kan ansöka om en klimatpremie från Energimyndigheten. Här får ni veta hur ansökan går till.';

export const smallImg001 = {
  src: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_Interior_FrontView.jpg',
  alt: 'inside car pv5',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full h-full object-cover',
};

export const climatePremiumIntro = {
  title: 'Vad är klimatpremien?',
  titleClass: 'text-[24px] font-[400] mb-4',
  text: '2024 införde Energimyndigheten en klimatpremie för lätta elbilar för att främja introduktionen av en viss typ av miljöfordon. Det innebär:',
  textClass: 'mb-6 text-[18px] font-[300] leading-[1.3]',
  listClass: 'ml-4 space-y-1 text-base font-[300]',
  listItems: [
    'Stödet är upp till 30 % av den stödberättigade kostnaden, men högst 40 000 kr per lätt elbil till och med den 31 oktober 2027.',
    'Klimatpremien upphör Klimatpremien upphör 1 november 2027.',
  ],
};

export const smallImg002 = {
  src: 'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_Interior_CargoView.jpg',
  alt: 'inside car pv5',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full object-cover',
};

export const applicationSection = {
  title: 'Vem kan ansöka?',
  titleClass: 'text-[20px] font-[400] mb-2',
  paragraphs: [
    'Företag, kommuner och regioner är berättigade stödet. För att stödet ska kunna betalas ut måste ni ha ett bankgiro eller plusgiro kopplat till organisationsnumret.',
    'Om ni leasar er lätta lastbil är det leasingbolaget som ansöker om stödet.',
  ],
  secondTitle: 'Hur ansöker jag?',
  secondTitleClass: 'text-[20px] font-[400] mb-4',
  stepsListClass: 'space-y-1 text-base font-[300]',
  steps: [
    "1. <a href='https://minasidor.energimyndigheten.se/'>Logga in på Mina sidor på Energimyndigheten med personligt BankID.</a>",
    '2. Ansök om behörighet till e-tjänsten Klimatpremie.',
    '3. När behörigheten är beviljad kan ni skicka in er ansökan.',
    '4. När ansökan är inskickad till Energimyndigheten kan ni beställa fordonet.',
  ],
  footerText:
    'Obs! För att ansökan ska vara giltig måste ni ansöka om stödet innan ni beställer bilen.',
  footerTextClass: 'mt-4 text-base font-light',
};

export const text002 =
  'För att en lätt lastbil ska vara berättigad Energimyndighetens klimatpremie ska den möta följande krav:';
export const textBoxCB = {
  title: '',
  backgroundColor: '',
  numberOfFields: 3,
  titleStyle: '',
  textSize: 'text-base md:text-lg font-light',
  listItems: [
    {
      text: 'Den ska vara registrerad som lastbil i Transportstyrelsens vägtrafikregister.',
      boldParts: [''],

      iconProps: { color: '#000', width: 22, height: 22, strokeWidth: 3 },
    },
    {
      text: 'Den får enbart drivas av el eller av el som producerats av vätgas via bränsleceller.',
      boldParts: [''],
      iconProps: { color: '#000', width: 22, height: 22, strokeWidth: 3 },
    },
    {
      text: 'Den har en totalvikt på maximalt 3,5 ton.',
      boldParts: [''],
      iconProps: { color: '#000', width: 22, height: 22, strokeWidth: 3 },
    },
  ],
};

export const img001 = {
  image:
    'https://kia-afonso-storage.b-cdn.net/PV5/KHQ_EV_Day_PV5_Cargo_KeyVisual_TopViewRear.jpg',
  title: 'Vilka lätta lastbilar är berättigade\n en klimatpremie? ',

  position: 'top' as const,
  hAlign: 'left' as const,
  titleClass: 'text-[clamp(24px,6vw,48px)] font-[400] ',
  subtitleClass: 'hidden',
};

export const faqBlockPL = {
  title: 'Vanliga frågor och svar om klimatpremien.',
  questions: [
    {
      q: 'Gäller stödet vid leasing?',
      a: 'Det är endast den som köpt fordonet och står som ägare för fordonet som är stödberättigad.</br></br>För att utbetalning ska kunna göras, måste den som sökt stödet, köpt och ställt på fordonet också vara registrerad som ägare i Transportstyrelsens vägtrafikregister och fordonet ska vara registrerat i Sverige.</br></br>Vanligtvis är leasinggivaren ägare av fordonet och leasingtagaren är brukare, i dessa fall innebär det alltså att leasinggivaren ska söka stödet.',
    },
    {
      q: 'Ska inköpspriset anges inklusive eller exklusive moms?',
      a: 'Om den sökande är momspliktig ska inköpspriset anges utan moms i ansökan om stöd.</br></br>Om den sökande är momsbefriad ska inköpspriset anges inklusive moms.</br></br>Det gäller både inköpspriset på fordonet och priset för närmast jämförbara fordon.',
    },
    {
      q: 'Vad gäller för utbetalning av stödet?',
      a: 'Energimyndigheten ska betala ut det beviljade stödbeloppet tidigast sex månader efter det att fordonet har ställts på i Transportstyrelsens vägtrafikregister</br></br>Beloppet betalas ut om uppgifterna i vägtrafikregistret visar att</br></br><ol><li>1: den som köpt och ställt på fordonet fortfarande är registrerad som ägare och</li><li>2: att fordonet är registrerat i Sverige, samt att övriga förutsättningar för utbetalning är uppfyllda.</li></ol>',
    },
  ],
};

export const linkCB01 = {
  text: 'Läs fler frågor och svar hos Energimyndigheten.',
  textSize: '16px',
  url: 'https://www.energimyndigheten.se/klimat/transporter/transporteffektivt-samhalle/klimatpremie-for-latta-ellastbilar/',
  className: 'mt-6 mb-6 text-center ml-0 sm:ml-2',
  widthClass: 'w-[300px] sm:w-fit sm:px-7',
  openInNewTab: true,
};
